import { Flex } from 'antd';
import UserMainLayout from '@/components/app/layouts/user-main-layout';
import TemplateView from '@/components/app/templates/template-view/TemplateView';
import AuthProtected from '@/components/app/utils/auth-protected/AuthProtected';
import { useRouter } from 'next/router';

export default function TemplatePage() {
   const router = useRouter();
   const { slug } = router.query;

   return (
      <div>
         <Flex vertical gap={32} p={8}>
            <TemplateView slug={slug} />
         </Flex>
      </div>
   );
}

TemplatePage.getLayout = (page) => (
   <AuthProtected>
      <UserMainLayout type="templates">{page}</UserMainLayout>
   </AuthProtected>
);
